import React from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

const PrivateRoute =  ({ component: Component, authProps, ...rest }) => (
  <Route {...rest} render={(props) => (
  		authProps.isAuthenticated ? <Component { ...props } {...authProps} /> :
  		<Redirect to="/login"/>
  	)} />
)

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/private-route.jsx